var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("popup", {
    staticClass: "calculator-popup",
    class: { default: !_vm.isFcTranz },
    attrs: {
      opened: _vm.openData,
      "use-footer": true,
      title: _vm.acnoInfo.drwotAcno ? _vm.acnoInfo.drwotAcno : "",
      "btn-area-padding": false
    },
    on: {
      "update:opened": function($event) {
        _vm.openData = $event
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c("article", { staticClass: "description" }, [
              _c("div", { staticClass: "breakdown" }, [
                _c("ul", { staticClass: "breakdown-list" }, [
                  _c("li", [
                    _c("ul", [
                      _c(
                        "li",
                        [
                          _vm.pageOption != "myQr"
                            ? [
                                _vm.acnoInfo.drwotAbilAmt >= 0
                                  ? _c("div", { staticClass: "item basic" }, [
                                      _c("div", { staticClass: "tit" }, [
                                        _vm._v(
                                          _vm._s(
                                            /*출금 가능 금액*/ _vm.$t(
                                              "MPAY-01-01-08-02"
                                            )
                                          )
                                        )
                                      ]),
                                      _c("div", { staticClass: "desc" }, [
                                        _c(
                                          "span",
                                          { staticClass: "exchange-unit" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.infoValue.drwotCncycd)
                                            )
                                          ]
                                        ),
                                        _c("span", { staticClass: "amount" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$num(
                                                _vm.acnoInfo.drwotAbilAmt
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm.acnoInfo.dailyTrsaccAcamtRmainLimt >= 0
                                  ? _c("div", { staticClass: "item basic" }, [
                                      _c("div", { staticClass: "tit" }, [
                                        _vm._v(
                                          _vm._s(
                                            /*1일이체잔여한도*/ _vm.$t(
                                              "MPAY-01-01-08-03"
                                            )
                                          )
                                        )
                                      ]),
                                      _c("div", { staticClass: "desc" }, [
                                        _c(
                                          "span",
                                          { staticClass: "exchange-unit" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.infoValue.drwotCncycd)
                                            )
                                          ]
                                        ),
                                        _c("span", { staticClass: "amount" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$num(
                                                _vm.acnoInfo
                                                  .dailyTrsaccAcamtRmainLimt
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ])
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ])
                ])
              ])
            ]),
            _c("article", { staticClass: "contents exchange-calculator" }, [
              _c(
                "div",
                {
                  staticClass: "exchange box-white",
                  class: { selected: _vm.fxTranz == "01" },
                  on: {
                    click: function($event) {
                      return _vm.setFxTranz("01")
                    }
                  }
                },
                [
                  _vm.pageOption == "payment"
                    ? _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "textfield1" }
                        },
                        [
                          _vm._v(
                            _vm._s(/*출금 금액*/ _vm.$t("MPAY-01-01-09-05"))
                          )
                        ]
                      )
                    : _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "textfield1" }
                        },
                        [
                          _vm._v(
                            _vm._s(/*입금 금액*/ _vm.$t("MPAY-01-01-09-04"))
                          )
                        ]
                      ),
                  _vm.fxTranz == "01"
                    ? _c("div", { staticClass: "calc-formula" }, [
                        _vm._v(_vm._s(_vm.formula))
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "input-text-field" }, [
                    _c("div", { staticClass: "nation" }, [
                      _c("span", { staticClass: "nation-name" }, [
                        _vm._v(_vm._s(_vm.infoValue.mnrcvCncycd))
                      ])
                    ]),
                    _c("div", { staticClass: "form-control" }, [
                      _vm.fxTranz == "01"
                        ? _c("i", {
                            staticClass: "icon icon-del",
                            on: {
                              click: function($event) {
                                return _vm.fnClear()
                              }
                            }
                          })
                        : _vm._e(),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.fxTranz == "01"
                              ? _vm
                                  .$utils()
                                  .Converter.numberWithCommas(_vm.current)
                              : _vm.fxTranzAmt > 0
                              ? _vm.$num(_vm.fxTranzAmt)
                              : ""
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm.minTrsaccAmtErrDstcd == "01" && _vm.isMinimunAmtErrorShow
                    ? _c("div", { staticClass: "min-amount" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              /*금액은 {min}이상 입력하셔야 합니다.*/ _vm.$t(
                                "validations.amtMinValue",
                                { min: _vm.minTrsaccAmt }
                              )
                            ) +
                            " "
                        )
                      ])
                    : _vm._e(),
                  _vm.fxTranz == "01" && _vm.isUsePointErrorShow
                    ? _c("div", { staticClass: "min-amount" }, [
                        _vm._v(
                          _vm._s(
                            /*소수점 이하는 입력할 수 없습니다.*/ _vm.$t(
                              "MPAY-01-01-09-06"
                            )
                          )
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm.isFcTranz
                ? _c(
                    "div",
                    {
                      staticClass: "exchange box-white",
                      class: { selected: _vm.fxTranz == "02" },
                      on: {
                        click: function($event) {
                          return _vm.setFxTranz("02")
                        }
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "textfield1" }
                        },
                        [
                          _vm._v(
                            _vm._s(/*출금 금액*/ _vm.$t("MPAY-01-01-09-05"))
                          )
                        ]
                      ),
                      _vm.fxTranz == "02"
                        ? _c("div", { staticClass: "calc-formula" }, [
                            _vm._v(_vm._s(_vm.formula))
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "input-text-field" }, [
                        _c("div", { staticClass: "nation" }, [
                          _c("span", { staticClass: "nation-name" }, [
                            _vm._v(_vm._s(_vm.infoValue.drwotCncycd))
                          ])
                        ]),
                        _c("div", { staticClass: "form-control" }, [
                          _vm.fxTranz == "02"
                            ? _c("i", {
                                staticClass: "icon icon-del",
                                on: {
                                  click: function($event) {
                                    return _vm.fnClear()
                                  }
                                }
                              })
                            : _vm._e(),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.fxTranz == "02"
                                  ? _vm
                                      .$utils()
                                      .Converter.numberWithCommas(_vm.current)
                                  : _vm.fxTranzAmt > 0
                                  ? _vm.$num(_vm.fxTranzAmt)
                                  : ""
                              )
                            )
                          ])
                        ])
                      ]),
                      _vm.minTrsaccAmtErrDstcd == "02" &&
                      _vm.isMinimunAmtErrorShow
                        ? _c("div", { staticClass: "min-amount" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  /*금액은 {min}이상 입력하셔야 합니다.*/ _vm.$t(
                                    "validations.amtMinValue",
                                    { min: _vm.minTrsaccAmt }
                                  )
                                ) +
                                " "
                            )
                          ])
                        : _vm._e(),
                      _vm.fxTranz == "02" && _vm.isUsePointErrorShow
                        ? _c("div", { staticClass: "min-amount" }, [
                            _vm._v(
                              _vm._s(
                                /*소수점 이하는 입력할 수 없습니다.*/ _vm.$t(
                                  "MPAY-01-01-09-06"
                                )
                              )
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              !_vm.isFcTranz
                ? _c("div", { staticClass: "calculator default" }, [
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("1")
                                  }
                                }
                              },
                              [_vm._v("1")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("2")
                                  }
                                }
                              },
                              [_vm._v("2")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("3")
                                  }
                                }
                              },
                              [_vm._v("3")]
                            )
                          ])
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("4")
                                  }
                                }
                              },
                              [_vm._v("4")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("5")
                                  }
                                }
                              },
                              [_vm._v("5")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("6")
                                  }
                                }
                              },
                              [_vm._v("6")]
                            )
                          ])
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("7")
                                  }
                                }
                              },
                              [_vm._v("7")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("8")
                                  }
                                }
                              },
                              [_vm._v("8")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("9")
                                  }
                                }
                              },
                              [_vm._v("9")]
                            )
                          ])
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend(".")
                                  }
                                }
                              },
                              [_vm._v(".")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("0")
                                  }
                                }
                              },
                              [_vm._v("0")]
                            )
                          ]),
                          _c("td", [
                            _c("span", {
                              staticClass: "btn back-del",
                              on: {
                                click: function($event) {
                                  return _vm.fnDel()
                                }
                              }
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                : _c("div", { staticClass: "calculator" }, [
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("7")
                                  }
                                }
                              },
                              [_vm._v("7")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("8")
                                  }
                                }
                              },
                              [_vm._v("8")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("9")
                                  }
                                }
                              },
                              [_vm._v("9")]
                            )
                          ]),
                          _c("td", [
                            _c("span", {
                              staticClass: "btn back-del",
                              on: {
                                click: function($event) {
                                  return _vm.fnDel()
                                }
                              }
                            })
                          ])
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("4")
                                  }
                                }
                              },
                              [_vm._v("4")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("5")
                                  }
                                }
                              },
                              [_vm._v("5")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("6")
                                  }
                                }
                              },
                              [_vm._v("6")]
                            )
                          ]),
                          _c("td", [
                            _c("span", {
                              staticClass: "btn minus",
                              on: {
                                click: function($event) {
                                  return _vm.fnSub()
                                }
                              }
                            })
                          ])
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("1")
                                  }
                                }
                              },
                              [_vm._v("1")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("2")
                                  }
                                }
                              },
                              [_vm._v("2")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("3")
                                  }
                                }
                              },
                              [_vm._v("3")]
                            )
                          ]),
                          _c("td", [
                            _c("span", {
                              staticClass: "btn plus",
                              on: {
                                click: function($event) {
                                  return _vm.fnAdd()
                                }
                              }
                            })
                          ])
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("00")
                                  }
                                }
                              },
                              [_vm._v("00")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend("0")
                                  }
                                }
                              },
                              [_vm._v("0")]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "num",
                                on: {
                                  click: function($event) {
                                    return _vm.fnAppend(".")
                                  }
                                }
                              },
                              [_vm._v(".")]
                            )
                          ]),
                          _c("td", [
                            _c("span", {
                              staticClass: "btn inequality",
                              on: {
                                click: function($event) {
                                  return _vm.fnCal()
                                }
                              }
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
            ])
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "button",
              {
                class:
                  "btn bottom " + (_vm.isBtnEnable ? "positive" : "disabled"),
                on: {
                  click: function($event) {
                    return _vm.fnEnter()
                  }
                }
              },
              [_vm._v(_vm._s(/*입력완료*/ _vm.$t("MPAY-01-01-09-07")))]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }